const API_KEY = process.env.VUE_APP_API_KEY || 'da2-oifafzt4gndxlgdv7of7hvu2kq';
const API_URL =
  process.env.VUE_APP_API_URL ||
  'https://ju6uqrwn2nbmdpfz6zmtyp6amy.appsync-api.us-east-1.amazonaws.com/graphql';
const API_REGION = process.env.VUE_APP_REGION || 'us-east-1';

export { API_KEY, API_URL, API_REGION };
